import { Component, ComponentRef, EventEmitter, OnInit, Output } from "@angular/core";
import { GeneralComponent } from "../general.component";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormularioService } from "src/app/services/formulario.service";
import { GeneralService } from "src/app/services/general.service";
import { NotificationService } from "src/app/services/notification.service";
import { MatDialog } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { Qua007CardIVComponent } from "src/app/views/form-qua007/partialViews/qua007-card-IV.component";
import { HttpErrorResponse } from "@angular/common/http";
import { DropDownListDTO } from "src/app/entity/dto/dropdownlist.component";
import { take } from "rxjs/operators";
@Component({
  selector: 'app-qua007-pesagem-item',
  templateUrl: './qua007-pesagem-item.component.html',
})
export class Qua007PesagemItemComponent extends GeneralComponent implements OnInit {

  public formulario?: FormGroup;
  public parentRef: Qua007CardIVComponent;
  public unique_key: number;
  public btnExcluir = false
  @Output() componentsReferences = Array<ComponentRef<Qua007PesagemItemComponent>>()
  @Output() mkCalc = new EventEmitter<Number>();
  @Output() loteDsDeletedEmitter = new EventEmitter();
  public listAlturaCamada?: DropDownListDTO[];
  public listAlturaCamadaOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  constructor(protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    public dialog: MatDialog,
    private add: Store<any>,) {
    super('', false);
    this.formulario = this.formBuilder.group({
      id: [null, []],
      numero_da_caixa: [null, [Validators.required]],
      Peso_bruto: [null, [Validators.required]],
      Peso_tara: [null, [Validators.required]],
      Peso_liquido: [0, [Validators.required]],

      Inicio_pesagem_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
      Inicio_pesagem_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],
      Termino_pesagem_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate), Validators.required]],
      Termino_pesagem_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour), Validators.required]],

      Familias_recebidas: [null, []],
      Altura_camada: ['0', [Validators.required]],
      controle_caixa: [null, []],
    });
  }
  async ngOnInit() {
    this.getListAlturaCamada()
  }
  hasErrorFormControl(campoFormulario: AbstractControl) {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }
  makeCalculations() {
    this.mkCalc.emit();
  }

  async getListAlturaCamada() {
    const site = this.generalService.getLocalStorageDataSite();
    await this.formularioService.getListDropDownList('qua_caixas', 'altura_camada', site).pipe(take(1)).toPromise().then((response: any) => {
      if (!!response?.data) {
        this.listAlturaCamada = this.generalService.orderByDropDownList(response.data as DropDownListDTO[], false);
        this.listAlturaCamadaOriginal = this.listAlturaCamada;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    });
  }
  public remove(lastItem = false) {
    // this.loteDsDeletedEmitter.emit();
    this.parentRef.removePesoItemComponent(this.unique_key, lastItem);
    // this.componentsReferences.pop();

  }

  calcPesoLiquido() {
    const pesoBruto = this.formulario.get('Peso_bruto')?.value as number
    const pesoTara = this.formulario.get('Peso_tara')?.value as number
    if (pesoBruto == null) {
      return
    }
    const calc = pesoBruto - pesoTara;
    this.formulario.get('Peso_liquido').setValue(Number(calc.toFixed(2)))
    this.makeCalculations();
  }

  createFilterAlturaCamada(value: string) {
    if (!!value && value.length > 0) {
      if (this.listAlturaCamadaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listAlturaCamada = this.listAlturaCamadaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listAlturaCamada = this.listAlturaCamadaOriginal;
      }
    } else {
      this.listAlturaCamada = this.listAlturaCamadaOriginal;
    }
  }
}